import { useContext, useState } from 'react';
import { notification } from 'antd';
import { AppContext } from '../../../App.context';
import { ApiContext } from '../../../utils/networking/Api.context';

const useRequestSuscriptionHook = enableAllHotels => {
  const {
    appState,
    appActions: { translate, getSelectedHotel },
  } = useContext(AppContext);
  const { API } = useContext(ApiContext);

  const [state, setState] = useState({
    isLoading: false,
    sendSuscriptionRequestEnabled: true,
  });

  const actions = {
    requestModuleFunctionality: ({ suscription }) => {
      updateState({ isLoading: true });

      const functionality = (() => {
        switch (suscription) {
          case 'payment':
            return 'Payment Module';
          case 'door_opening':
            return 'Door Opening Module';
          case 'guestlink':
            return 'Guestlink Module';
          case 'checkout':
            return 'Checkout Module';
          case 'checkin':
            return 'Checkin Module';
          case 'sftp':
            return 'Checkin SFTP';
          case 'hbx_hcn':
            return 'HCN';
          case 'hbx_invoicing':
            return 'Invoice Automation';
          case 'bookings_report':
            return 'Reservations Report';
          default:
            return 'Unknown Module';
        }
      })();

      API.requestFunctionalityContract({
        hotelId: getSelectedHotel().key,
        suscription,
        functionality,
      })
        .then(_ => {
          actions.sendRequestPoliceFunctionalityEmail({ functionality });
        })
        .catch(_ => {
          updateState({ isLoading: false });
        });
    },

    sendRequestPoliceFunctionalityEmail: ({ functionality }) => {
      API.sendRequestFuncionalityEmail({
        hotelId: getSelectedHotel().key,
        functionality,
      })
        .then(_ => {
          notification.success({
            message: translate('requestSuscription.missingSuscription.requestSent'),
          });
          updateState({ isLoading: false, sendSuscriptionRequestEnabled: false });
        })
        .catch(_ => {
          updateState({ isLoading: false });
        });
    },

    getTitleModule: subscription => {
      switch (subscription) {
        case 'payment':
          return translate('payment.missingSuscription.title');
        case 'door_opening':
          return translate('doorOpening.missingSuscription.title');
        case 'guestlink':
        case 'sftp':
          return translate('guestlink.missingSuscription.title');
        case 'checkout':
          return translate('checkOutModule.missingSubscription.title');
        case 'checkin':
          return translate('checkInList.missingSubscription.title');
        case 'hbx_hcn':
          return translate('hbxProducts.missingSubscriptionHcn.title');
        case 'hbx_invoicing':
          return translate('hbxProducts.missingSubscriptionAutoInvoice.title');
        case 'bookings_report':
          return translate('policeReport.missingSubscription.title');
        default:
          return 'Unknown module';
      }
    },

    getDescriptionModule: subscription => {
      switch (subscription) {
        case 'payment':
          return translate('payment.missingSuscription.description');
        case 'door_opening':
          return translate('doorOpening.missingSuscription.description');
        case 'guestlink':
          return translate('guestlink.missingSuscription.description');
        case 'checkout':
          return translate('checkOutModule.missingSubscription.description');
        case 'checkin':
          return translate('checkInList.missingSubscription.description');
        case 'sftp':
          return translate('sftp.missingSubscription.description');
        case 'hbx_hcn':
          return translate('hbxProducts.missingSubscriptionHcn.description');
        case 'hbx_invoicing':
          return translate('hbxProducts.missingSubscriptionAutoInvoice.description');
        case 'bookings_report':
          return translate('policeReport.missingSubscription.description');
        default:
          return '';
      }
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
};

export default useRequestSuscriptionHook;
